window.dataLayer = window.dataLayer || [];
var site = site || {};
var randomPrize = randomPrize || {};

(function ($) {
  // Properties
  var _spinningActive = false;
  var currentlyShowing = 0;
  var cubeFlashes = parseInt($('.game-landing').data('cube-flashes')) || 25; // Or the default
  var cubeCount = 0;
  var _getNewPrize = false;

  /**
   * On Click Function for the Play Button
   *
   * @returns {bool} false
   */
  function playGame() {
    if ($(this).hasClass('disabled')) {
      return;
    }

    if (isAlreadyPlayed()) {
      alreadyPlayedPopup();

      return;
    }

    $('.play-button-bg').toggle();
    if (_spinningActive) {
      return;
    }

    _spinningActive = true;

    // Okay now play the game
    var gameCubes = $('.game-grid-cube-off');
    var randomCube = ensureRandomNumber(gameCubes.length, currentlyShowing);

    cubeReveal(randomCube, gameCubes);

    dataLayer.push({
      'event': 'siteGame',
      'eventCategory': 'Spinner',
      'eventAction': 'Play',
      'eventLabel': 1
    });
  }

  function cubeReveal($randomCube, $gameCubes) {
    $gameCubes.eq($randomCube).fadeOut(150).delay(15).fadeIn(150, function () {
      if (cubeCount >= cubeFlashes) {
        cubeSelect($randomCube, $gameCubes);

        return;
      }
      currentlyShowing = $randomCube;
      var randomCube = ensureRandomNumber($gameCubes.length, currentlyShowing);

      cubeCount++;
      cubeReveal(randomCube, $gameCubes);
    });
  }

  function cubeSelect($randomCube, $gameCubes) {
    $gameCubes.eq($randomCube).fadeOut(150).delay(15).fadeIn(150, function () {
      $gameCubes.eq($randomCube).fadeOut(150).delay(15).fadeIn(150, function () {
        $gameCubes.eq($randomCube).fadeOut(150).delay(15).fadeIn(150, function () {
          var willWin = randomPrize._winOrNoWin();

          showResult(willWin);
        });
      });
    });
  }

  /**
   * Generates a random number but insure it's not one found within an array
   *
   * @param {number} $max - Max number to generate
   * @param {array} $exclude - Array Don't be any of these
   *
   * @returns {number} Random number
   */
  function ensureRandomNumber($max, $exclude) {
    $exclude = $exclude || 0;
    var num = Math.floor(Math.random() * $max);

    if ($exclude === num) {
      return ensureRandomNumber($max, $exclude);
    }

    // return the num
    return num;
  }

  /**
   * Show if the user has won / lost
   *
   * @returns {boolean} false
   */
  function showResult($willWin) {
    _spinningActive = false;
    $('.play-button-bg').toggle();
    var offerCode = '';

    // Have they won
    if (_currentTry >= _tries || $willWin) {
      // SHOW WINNER MESSAGE
      var winningOfferInfo = randomPrize._getWinningOffer();

      offerCode = winningOfferInfo.winning_offer.offer_code;
      showWinBox(winningOfferInfo);
      dataLayer.push({
        'event': ' siteGameWin',
        'eventCategory': 'Spinner',
        'eventAction': 'Win',
        'eventLabel': 1,
        'wonProduct': offerCode
      });
    } else {
      // SHOW LOSE MESSAGE
      $('#game-lose-box').fadeIn(300);
      offerCode = 'none';
    }
    if (!randomPrize._get24HourCookie()) {
      randomPrize._set24HourCookie(1);
      randomPrize.setWinningOfferCookie(offerCode);
    }
  }

  /**
   * Shows the Win Box
   *
   * @param {Object} $fields - fields used to populate the win box
   * @returns {bool} false
   */
  function showWinBox($fields) {
    // If there is no param this will not work
    if (!$fields) {
      return false;
    }
    // Set the win box that the game will use
    // Populate the fields of the win box
    $('#game-win-box .win-offer-message').html($fields.confirmMessage);
    $('#game-win-box .win-image').css('background-image', 'url(' + $fields.image + ')');
    if (!$fields.playAgain) {
      $('#game-win-box .try-again-btn').hide();
      $('#game-win-box .apply_offer_subtext').hide();
    } else {
      _getNewPrize = true;
    }

    // inject terms and conditions
    var terms = $('#win_popup_box_tcs').val().split('^===^');
    var offerCode = randomPrize._getWinningOffer().winning_offer.offer_code;
    var string = terms[randomPrize.offer_array.indexOf(offerCode)];

    $('#game-win-box .game-tcs p').html(string);

    // Fade in the box
    $('#game-win-box').fadeIn(300);
  }

  function shopNowRedirect() {
    var shopNowUrls = $('#shop_now_urls').val().split('^===^');
    var offerCode = randomPrize._getWinningOffer().winning_offer.offer_code;
    var url = shopNowUrls[randomPrize.offer_array.indexOf(offerCode)];

    location.href = url;
  }

  function isAlreadyPlayed() {
    return randomPrize.getWinningOfferCookie() && randomPrize._get24HourCookie();
  }

  function alreadyPlayedPopup() {
    var offerCodeCookie = randomPrize.getWinningOfferCookie();

    if (offerCodeCookie == 'none') {
      $('#game-lose-box').fadeIn(300);
    } else {
      showWinBox(randomPrize._getWinningOffer());
    }
  }

  function initRandomPrize() {
    randomPrize.stopGameFor24HoursOnceWon = 0;
    randomPrize.init();

    _tries = randomPrize.nodes.number_of_tries;
    _currentTry = parseInt(randomPrize._getNumberOfTriesCookie());

    $.when(randomPrize.offerApplied).then(function () {
      shopNowRedirect();
    });

    $.when(randomPrize.GameReady).then(function () {
      if (isAlreadyPlayed()) {
        randomPrize._hideLoading();
        alreadyPlayedPopup();
      }
    });
  }

  Drupal.behaviors.prizeGrid = {
    attach: function (context, settings) {
      $('.play-button').on('click', playGame);
      $('#win-box .play-again').on('click', playGame);

      initRandomPrize();

      $('.pop-up-box-inner .close').on('click', function (e) {
        e.preventDefault();
        $(this).closest('.pop-up-box').fadeOut(300);
      });
    }
  };
})(jQuery);
